angular.
module("dx.webapp.lists").
directive("dxRubriclist", function rubriclistDirective() {
	"use strict";

	return {
		restrict: "E",
		templateUrl: "tmpl/lists/rubriclist-directive.html",
		scope: {
			rubrics: "=",
		},
		controller: "DxRubriclistController",
		controllerAs: "vm",
		bindToController: true,
	};
});
